/**
 * Main Entry Point
 *
 * Renders the React application. Loads Geist Variable + Geist Mono Variable
 * fonts BEFORE the global stylesheet so fonts are ready when the first paint
 * happens. Provider order matters: ErrorBoundary (outermost so it catches
 * provider errors too) → ThemeProvider → DensityProvider → AuthProvider →
 * App.
 */

// Fonts first — load before index.css so font-family fallbacks resolve cleanly.
import '@fontsource-variable/geist';
import '@fontsource-variable/geist-mono';

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { ErrorBoundary } from './components/ErrorBoundary';
import { ThemeProvider } from './components/ThemeProvider';
import { DensityProvider } from './components/DensityProvider';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <ThemeProvider>
        <DensityProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </DensityProvider>
      </ThemeProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
